import React from 'react'
import Terms from 'app/components/checkout/steps/partials/Terms'
const Trans = require('app/components/trans/Trans')

export default class InvoiceTerms extends Terms {
  get checkboxId () {
    return 'invoiceTermsCheckbox'
  }

  renderLabelContents () {
    return (
      <>
        <Trans> Jeg har opgivet korrekte data og accepterer samtykkeerklæringen </Trans>
      </>
    )
  }

  renderTerms () {
    return (
      <>
       <Trans> <p>Det erklæres herved at oplysningerne til fakturering er fyldestgørende for fremsendelse og godkendelse af
          faktura.
        </p>
        <p>Jeg er indforstået med, at afvises fakturaen på grund af, at de afgivne oplysninger er ufuldstændige,
          da kan der faktureres for dobbelthåndtering jf. salgs- og leveringsbetingelserne.
        </p>
       </Trans>
      </>
    )
  }
}
